import { ContentLibraryFieldModel } from '../../../Common/PageBuilder/models/content-library-field-model';
import { StyleTypesApiEnum } from '../../../api/styles/enum/style-types-api.enum';
import { webVideoHelper } from '../../../Common/Misc/helpers/webVideo/webVideo.helper';
import { ImageSettingsFieldComponent } from '../../../Common/PageBuilder/components/FormFields/ImageSettingsField/image-settings-field.component';
import { PanelFieldComponent } from '../../../Common/PageBuilder/components/FormFields/PanelField/panel-field.component';
import { TextFieldComponent } from '../../../Common/PageBuilder/components/FormFields/TextField/text-field.component';
import { RichTextBlockComponent } from '../../../Common/PageBuilder/components/RichTextBlock/rich-text-block.component';
import { BlockTypeModel } from '../../../Common/PageBuilder/models/block-type.model';
import { ImageDisplayElementModel } from '../../../Common/PageBuilder/models/image-display-element.model';
import { ImageSettingsFieldModel } from '../../../Common/PageBuilder/models/image-settings-field.model';
import { PanelFieldModel } from '../../../Common/PageBuilder/models/panel-field.model';
import { RichTextDisplayElementModel } from '../../../Common/PageBuilder/models/rich-text-display-element.model';
import { TextFieldModel } from '../../../Common/PageBuilder/models/text-field.model';
import { VideoDisplayElementModel } from '../../../Common/PageBuilder/models/video-display-element.model';
import { SocialLinkFieldComponent } from '../components/SocialLinkField/social-link-field.component';
import { SocialLinksStyleFieldComponent } from '../components/SocialLinksStyleField/social-links-style-field.component';
import { WireBlockTypeEnum } from '../enums/wire-block-type.enum';
import { ContactDisplayElementModel } from './contact-display-element.model';
import { SocialLinkDisplayElementModel } from './social-link-display-element.model';
import { SocialLinkFieldModel } from './social-link-field.model';
import { SocialLinksStyleFieldModel } from './social-links-style-field.model';
import { WireCompanyBioModel } from './wire-company-bio.model';
import { ContentLibraryPanelFieldComponent } from '../../../Common/PageBuilder/components/FormFields/ContentLibraryPanelField/content-library-panel.component';

export const wireTextBlockType = new BlockTypeModel(
    WireBlockTypeEnum.text,
    'PageBuilder.blockType.text',
    'fa-solid fa-align-left',
    null,
    RichTextDisplayElementModel,
    [],
    RichTextBlockComponent
);

export const wireImageBlockType = new BlockTypeModel(
    WireBlockTypeEnum.image,
    'PageBuilder.blockType.image',
    'fa-regular fa-duotone fa-image',
    null,
    ImageDisplayElementModel,
    [
        new ContentLibraryFieldModel(
            ContentLibraryPanelFieldComponent,
            'image',
            'Briefings.fields.image.imageUpload',
            {
                description: 'PageBuilder.formField.uploadDescription',
                accepts: 'image/gif, image/jpeg, image/png',
                maxFiles: 1,
                buttonLabel: 'PageBuilder.formField.urlLabel',
                placeholder: 'PageBuilder.formField.urlLabel',
                required: false,
                defaultValue: undefined,
                validators: [(control) => {
                    const value = control.value as string;
                    if (value?.length > 1000) {
                        return { largeUrl: 'PageBuilder.formField.link.largeUrl' };
                    }
                    return null;
                }]
            }
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Amplify.fields.image.imageSettings',
            '',
            [
                new ImageSettingsFieldModel(
                    ImageSettingsFieldComponent,
                    'settings',
                    'PageBuilder.formField.uploadLabel',
                    'PageBuilder.formField.uploadDescription',
                    false,
                    true,
                    false
                )
            ]
        )
    ]
);

export const wireVideoBlockType = new BlockTypeModel(
    WireBlockTypeEnum.video,
    'PageBuilder.blockType.video',
    'fa-regular fa-duotone fa-video',
    null,
    VideoDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Amplify.fields.video.settings',
            '',
            [
                new TextFieldModel(
                    TextFieldComponent,
                    'url',
                    'Amplify.fields.video.url',
                    null,
                    false,
                    128,
                    'Amplify.fields.video.placeholder',
                    true,
                    '',
                    (value: string) => {
                        if (!webVideoHelper.isYoutubeURL(value) && !webVideoHelper.isVimeoURL(value)) {
                            return 'Amplify.fields.video.error';
                        }

                        return '';
                    }
                ),
                new TextFieldModel(
                    TextFieldComponent,
                    'caption',
                    'Amplify.fields.video.caption',
                    null,
                    false,
                    128,
                    'Amplify.fields.video.caption.placeholder',
                    true,
                    'Amplify.fields.video.caption.tooltip'

                ),
            ]
        ),
    ]
);

export const wireLinksBlockType = new BlockTypeModel(
    WireBlockTypeEnum.links,
    'PageBuilder.blockType.links',
    'fa-regular fa-duotone fa-link',
    null,
    SocialLinkDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Amplify.fields.links.settings.linksHeader',
            '',
            [
                new SocialLinkFieldModel(SocialLinkFieldComponent),
            ]
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Amplify.fields.links.settings.linksSettings',
            '',
            [
                // TODO: Determine if needed
                // new CheckboxFieldModel(
                //     CheckboxFieldComponent,
                //     'isBoundToGlobalStyles',
                //     '',
                //     '',
                //     new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                //     true
                // ),
                new SocialLinksStyleFieldModel(
                    'styles',
                    SocialLinksStyleFieldComponent,
                    'PageBuilder.formField.linkLabel',
                    null,
                    StyleTypesApiEnum.LINK
                )
            ]
        )
    ]
);

export const wireContactBlockType = new BlockTypeModel(
    WireBlockTypeEnum.contact,
    'PageBuilder.blockType.contact',
    'fa-regular fa-duotone fa-user',
    null,
    ContactDisplayElementModel,
    []
);

// F.E fake block types, B.E use normal fields to store them
export const wireCompanyLogoBlockType = new BlockTypeModel(
    WireBlockTypeEnum.companyLogo,
    'Amplify.fakeBlockType.companyLogo',
    'fa-regular fa-regular fa-duotone fa-circle-star',
    null,
    null,
    []
);

export const wireCompanyBioBlockType = new BlockTypeModel(
    WireBlockTypeEnum.companyBio,
    'Amplify.component.companyBio',
    'fa-regular fa-duotone fa-book',
    null,
    WireCompanyBioModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Amplify.component.companyBio',
            '',
            [
                new TextFieldModel(
                    TextFieldComponent,
                    'companyBio',
                    'Amplify.component.companyBio',
                    null,
                    true,
                    512,
                    'Amplify.component.companyBio.field.placeholder',
                ),
            ]
        )
    ]
);

export const wireCompanyAddressBlockType = new BlockTypeModel(
    WireBlockTypeEnum.companyAddress,
    'Amplify.fakeBlockType.companyAddress',
    'fa-regular fa-duotone fa-envelope',
    null,
    null,
    []
);

export const wireBlockTypeEnumToBlockTypeMap: Map<WireBlockTypeEnum, BlockTypeModel> = new Map(
    [
        [WireBlockTypeEnum.text, wireTextBlockType],
        [WireBlockTypeEnum.image, wireImageBlockType],
        [WireBlockTypeEnum.companyLogo, wireCompanyLogoBlockType],
        [WireBlockTypeEnum.companyBio, wireCompanyBioBlockType],
        [WireBlockTypeEnum.contact, wireContactBlockType],
        [WireBlockTypeEnum.companyAddress, wireCompanyAddressBlockType],
        [WireBlockTypeEnum.video, wireVideoBlockType],
        [WireBlockTypeEnum.links, wireLinksBlockType],
    ]
);

export const wireBlockTypes: BlockTypeModel[] = [
    wireCompanyLogoBlockType,
    wireImageBlockType,
    wireVideoBlockType,
    wireTextBlockType,
    wireCompanyBioBlockType,
    wireLinksBlockType,
    wireContactBlockType,
    wireCompanyAddressBlockType
];
